"use client"
import { useState, useEffect, useRef } from "react"
import "./MobileSolution.css"
import BlueSectionDivider from "./BlueSectionDivider"

const numbers = [
  { num: "+20", text: "Industry sectors" },
  { num: "78", text: "Customer NPS score" },
  { num: "99%", text: "Recommendation rate" },
  { num: "+300", text: "Projects delivered" },
]

const cards = [
  {
    id: 1,
    img: "/apple.webp?height=60&width=60",
    title: "iOS APP DEVELOPMENT",
  },
  {
    id: 2,
    img: "/android.webp?height=60&width=60",
    title: "ANDROID APP DEVELOPMENT",
  },
  {
    id: 3,
    img: "/cross.webp?height=60&width=60",
    title: "CROSS-PLATFORM APP DEVELOPMENT",
  },
  {
    id: 4,
    img: "/ipad.webp?height=60&width=60",
    title: "IPAD APP DEVELOPMENT",
  },
  {
    id: 5,
    img: "/mobile.webp?height=60&width=60",
    title: "MOBILE APP INTEGRATION",
  },
  {
    id: 6,
    img: "/enterprise.webp?height=60&width=60",
    title: "ENTERPRISE APPS",
  },
]

const MobileSolution = (props) => {
  const [active, setActive] = useState("solution") // State for this navbar's active link
  const cardRefs = useRef([])
  const headingRef = useRef(null)
  const paraRef = useRef(null)

  // Define section IDs for the mobile-solutions-navbar highlighting based on actual section IDs in this component
  // Currently, only the main section has an ID. If you add more sections with IDs, include them here.
  const sectionsToHighlight = [
    "solution",
    "process",
    "benefits",
    "team",
    "tech-stack",
    "faq",
    "contact-us" ,// This is the ID of the main section
    // Add other section IDs here if they exist within MobileSolution.jsx
    // e.g., "process", "benefits", etc.
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.2 },
    )
    ;[...cardRefs.current, headingRef.current, paraRef.current].forEach((ref) => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])

  // Effect for the mobile-solutions-navbar highlighting
  useEffect(() => {
    const handleScroll = () => {
      // Approximate height of this mobile-solutions-navbar
      // You might need to adjust this value based on the actual height of your navbar
      const mobileSolutionsNavbarHeight = 60
      const scrollPosition = window.scrollY + mobileSolutionsNavbarHeight + 20 // Add a small buffer

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i])
        if (section && section.offsetTop <= scrollPosition) {
          // Map section ID "solution" to navbar link "solutions"
          const activeLink = sectionsToHighlight[i] === "solution" ? "solutions" : sectionsToHighlight[i]
          setActive(activeLink)
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // Call once to set initial state

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleClick = (id) => {
    // Map navbar link text "solutions" back to section ID "solution"
    const sectionId = id === "solutions" ? "solution" : id
    setActive(id) // Set active state to the clicked navbar item text
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <>
     <div className="mobile-solutions-navbar64">
      <div className="container">
        <ul>
          {["solutions", "process", "benefits", "team", "tech stack", "faq", "contact us"].map((item) => (
            <li key={item}>
              <a onClick={() => handleClick(item)} className={active === item ? "active" : ""}>
                {item.toUpperCase()}
              </a>
            </li>
          ))}
        </ul>
        </div>
      </div>
    <section className="mobile-solutions-section" id="solution">
      <div className="container">
     
      <div className="content">
        <div className="numbers-row">
          {numbers.map((n) => (
            <div key={n.num} className="number-block">
              <div className="big-num">{n.num}</div>
              <div className="num-text">{n.text}</div>
            </div>
          ))}
        </div>
        <BlueSectionDivider />
        <div className="mobile-solutions-header">
          <h2 ref={headingRef} className="fade-in-left">
            OUR <br />
            <span className="blue">SOLUTIONS</span>
          </h2>
          <p className="mobile-solutions-intro fade-in-right" ref={paraRef}>
            Our expertise covers an array of areas, from simples projects such as website building to highly complex web
            based applications.
          </p>
        </div>
        <div className="mobile-solutions-cards">
          {cards.map((card, idx) => (
            <div key={card.id} className="mobile-solution-card fade-up" ref={(el) => (cardRefs.current[idx] = el)}>
              <img src={card.img || "/placeholder.svg"} alt="icon" className="card3-icon" />
              <h3>{card.title}</h3>
            </div>
          ))}
        </div>
      </div>
      <div className="down-btn">
        <button>SEE INDUSTRIES WE WORK IN</button>
      </div>
      {/* Placeholder sections for other navbar links if they were to exist */}
      {/* <section id="process" style={{ height: "500px", background: "#e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "50px" }}><h2>PROCESS Section</h2></section> */}
      {/* <section id="benefits" style={{ height: "500px", background: "#d0d0d0", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "50px" }}><h2>BENEFITS Section</h2></section> */}
      {/* ... and so on for team, tech stack, faq, contact us */}
       </div>
    </section>
   
    </>
  )
}

export default MobileSolution
